export const precisionMarks = [0, 1, 2].map(mark => {
  return { value: mark };
});

export const sliderSx = {
  '& .MuiSlider-thumb': {
    height: 20,
    width: 4,
    borderRadius: 0,
  }
};

export const sliderLabel = 'Grid Precision';